










































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { Subscription } from "@teacherskaya/api-provider/dist/api/SubscriptionProvider";
import { TableItem, TableItems } from "@/types";
import BaseTable from "@/components/BaseTable.vue";
import { $t } from "@/lib/helpers/i18nHelper";
import { formatMoney } from "@/lib/helpers/money";
import { Location } from "vue-router";
import { formatDate, isAfter } from "@/lib/helpers/time";
import emitter from "@/lib/helpers/emitter";

@Component({ name: "RecurringTable", components: { BaseTable } })
export default class RecurringTable extends Vue {
  @Prop({ type: Array, required: true })
  public readonly subscriptions!: Subscription[];

  @Prop({ type: Boolean, default: false })
  public readonly isSubscribers!: boolean;

  public get items(): TableItems {
    return this.subscriptions.map(subscription => {
      const user = this.isSubscribers ? subscription?.consumer : subscription?.provider;
      return {
        id: subscription.id,
        cancelled: subscription.recurringBillingSchedule?.cancelled ?? true,
        expired: this.isExpired(subscription),
        userId: this.isSubscribers ? subscription.consumerId : subscription.providerId,
        screenName: user === null ? "System" : user?.screenName,
        price: formatMoney(subscription.amount),
        billingAmount: subscription.recurringBillingSchedule
          ? formatMoney(
              subscription.recurringBillingSchedule.cost.cost,
              subscription.recurringBillingSchedule.cost.currency
            )
          : $t("No billed amount"),
        billingDate: subscription.recurringBillingSchedule
          ? formatDate(subscription.recurringBillingSchedule.schedule.nextBillingTime)
          : formatDate(subscription.expirationTime),
        actions: true,
        hasRecurring: !!subscription.recurringBillingSchedule,
      };
    });
  }

  public get profileLink() {
    return (row: TableItem): Location => {
      const userId = row.userId ? row.userId.toString() : "";
      return {
        name: "profile",
        params: { userId },
      };
    };
  }

  public onActionClick(id: string, eventName: string) {
    const subscription = this.subscriptions.find(item => item.id === id);
    if (!subscription) return;
    const name = this.isSubscribers ? "pageSubscribers" : "pageSubscriptions";
    emitter.emit("showConfirmRecurringAction", { name, subscription, eventName });
  }

  public isExpired(subscription: Subscription) {
    return isAfter(new Date(), new Date(subscription.expirationTime));
  }
}
